import { faShareSquare, faExternalLink, faUser } from '@fortawesome/pro-light-svg-icons';
import { IAction } from './interfaces';
import { AssignCasesCaseworkerDialog } from '../modals/assign-cases-caseworker-dialog/assign-cases-caseworker-dialog';
import { AssignAssociatedcaseworkerCases } from '../modals/add-associatedcaseworker-cases/assign-associatedcaseworker-cases';
import { SELECTION_CAP } from 'areas/search/hooks';
export const actions: IAction[] = [
  {
    context: 'Cases',
    id: 'AssignTeamOrUser',
    displayName: 'Tildel',
    icon: faShareSquare,
    action: (selectedEntries, _selectedRootIds, _isFeatureEnabled, _replaceUrl, _selectedEntities, onActionCompleted) => (
      <AssignCasesCaseworkerDialog caseIds={selectedEntries} onCompleted={onActionCompleted} />
    ),
    isVisible: selectedItemsCount => selectedItemsCount > 0,
    isDisabled: selectedItemsCount => (selectedItemsCount > SELECTION_CAP ? `Antallet af valgte elementer må ikke overstige ${SELECTION_CAP}` : ''),
  },
  {
    context: 'Cases',
    id: 'ShowLink',
    displayName: 'Vis link',
    icon: faExternalLink,
    action: selectedEntities => {
      let preText = '';
      let text = '';
      selectedEntities.forEach(entry => {
        const link = `${window.location.origin}/gotoresource/si_case?resourceId=${entry.replace(/[{}]/g, '')}`;
        text += `${preText}${link}`;
        preText = '\r\n\r\n';
      });
      // eslint-disable-next-line no-alert
      window.prompt('Kopiér link til udklipsholder: Ctrl+C, Enter', text);
    },
    isVisible: selectedItemsCount => selectedItemsCount > 0,
    isDisabled: selectedItemsCount => (selectedItemsCount > 10 ? 'Antallet af valgte elementer må ikke overstige 10' : ''),
  },
  {
    context: 'Cases',
    id: 'AddAssociatedUser',
    displayName: 'Tilføj supplerende sagsbehandler',
    isVisible: selectedItemsCount => selectedItemsCount > 0,
    isDisabled: selectedItemsCount => (selectedItemsCount > SELECTION_CAP ? `Antallet af valgte elementer må ikke overstige ${SELECTION_CAP}` : ''),
    icon: faUser,
    action: (selectedEntries, selectedRootIds, _isFeatureEnabled, _replaceUrl, _selectedEntities, onActionCompleted) => (
      <AssignAssociatedcaseworkerCases citizenIds={selectedRootIds} caseIds={selectedEntries} onCompleted={onActionCompleted} />
    ),
  },
];
